module.exports = __webpack_public_path__ + "img/yishi25.11b58331.jpg";